import React from 'react';
import ReactDOM from 'react-dom';
import {AiOutlineCloseCircle} from 'react-icons/ai';
import {EMAIL} from '../utils/Constants.js';
const Contact = ({ isShowing, hide }) => isShowing ? ReactDOM.createPortal(
  <React.Fragment>
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal-overlay" onClick={hide}/>
      <div className="modal">
        <div className="modal-header">
          <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
            <span aria-hidden="true"><AiOutlineCloseCircle/></span>
          </button>
        </div>
        <div className='center'>
          <h1>Contact Info</h1>
          <p>For any questions or comments about this experiment, please contact:</p>
          <p><a className='contact' style={{textDecorationLine: 'none'}} href={"mailto:"+EMAIL}>{EMAIL}</a></p>
        </div>
      </div>
    </div>
  </React.Fragment>, document.body
) : null;

export default Contact;
